import AxiosErrorHandler from '@/api/AxiosErrorHandler';
import api from '@/api/API';

export default new AxiosErrorHandler(api);
